import { useMutation } from "@tanstack/react-query";
import { apiClient } from "../service/tekkr-service";
import { useProject } from "../project";

interface Input {
    name?: string;
    creatorId?: string;
}

export function useUpdateProjectMutation() {
    const { project, refetch: refetchProject } = useProject();
    return useMutation({
        mutationFn: async (input: Input) => {
            await apiClient.updateProject({
                params: {
                    id: project.id,
                },
                body: {
                    name: input.name,
                    creatorId: input.creatorId,
                },
            });
            await refetchProject();
        },
    });
}

export function useTransferProjectOwnershipMutation() {
    const { project } = useProject();
    return useMutation({
        mutationFn: async (creatorId: string) => {
            await apiClient.updateProject({
                params: {
                    id: project.id,
                },
                body: {
                    creatorId,
                },
            });
        },
    });
}
